import React, {useContext} from 'react';
import compact from 'lodash/compact';

import {Select} from 'components';
import * as utils from 'utils';

import styles from './FilterLanguages.module.scss';
import Context from '../../../../context';
import {reducerFilters} from '../../../../reducers';

export const FilterLanguages = () => {
  const {
    data,
    loading,
    filters: {languages},
    dispatchFilters,
  } = useContext(Context);

  const arrOptions = compact([...new Set(data.map(item => item.language))]);
  const options = arrOptions.map(label => ({
    value: `languages--${label}`,
    label,
  }));

  const handleChange = values => {
    // Tracking Analytics
    const items = values.map(item => item.label).join(', ');
    utils.handleAnalytics('dropdown', 'languages', items);

    dispatchFilters({
      type: reducerFilters.actionTypes.updateLanguages,
      payload: values || [],
    });
  };

  return (
    <Select
      className={styles.wrap}
      multiple
      placeholder="All Languages"
      controlAmountText="languages"
      value={languages}
      options={options}
      loading={loading}
      onChange={handleChange}
    />
  );
};

FilterLanguages.defaultProps = {};

FilterLanguages.propTypes = {};
